module.exports = __webpack_public_path__ + "img/bg_6.0ce8baf4.jpg";